<div class="container">
  <ion-input (input)="onInputChange($event.target.value)" [(ngModel)]="searchText" [placeholder]="placeholderText"
    class="invite-input {{theme}}-input" type="email" autocapitalize="off" autocorrect="off" spellcheck="false">
    <ion-icon class="link" *ngIf="searchText" slot="end" (click)="clearSearch()" name="close-circle"></ion-icon>
  </ion-input>
  <ion-button (click)="sendInviteEmail()" [disabled]="!emailIsValid()" class="invite-button {{theme}}-button"
    fill="outline" [class.hide]="hideInviteButton" data-cy="algolia-inviteBtn"><ion-label>Invite</ion-label>
  </ion-button>
</div>

<div class="hits" [hidden]="hits.length === 0">
  <div class="hit link" *ngFor="let hit of hits">
    <!-- Passing `true` to `searchInviteMode` makes it so when you click on the item you will trigger the invite -->
    <app-public-profile-item [searchInviteMode]="!disableInviteOnResultClick" (click)="onResultClick(hit)"
      [pairedAgentData]="hit" [showControls]="false" [showContact]="false" [showSocial]="false" [showInvite]="false" />
  </div>
</div>

<div *ngIf="searchText && !hits.length" class="no-results-label">
  {{ noResultsMessage }}
</div>